import React from "react";

import CheatingReprimandRowCard from "./RowCard";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import { useCustomQuery } from "utilities/hookutils";
import { Loading } from "components/panels";

const CheatingReprimands = () => {

  const cheatingReprimands = useCustomQuery({
    queryKey: ["cheatingReprimands"],
    queryFn: () => window.CoreApi.AdminOne.ListReprimands().then(res => res.data.data),
    initialData: []
  });

  return <SectionPanel.Panel
    collapsible={{ start: "open", uniqueRowId: "cheating-reprimands-panel", persist: true }}
    header={<PanelSegment.Title title="Multi-use reprimands" />}
  >
    {cheatingReprimands.isLoading && <Loading />}

    {!cheatingReprimands.isLoading && <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">
        {cheatingReprimands.data?.map((cheatingReprimand, idx) => (
          <CheatingReprimandRowCard
            key={idx}
            cheatingReprimand={cheatingReprimand}
          />
        ))
        }
      </div>
    </div>}
  </SectionPanel.Panel>
};

export default CheatingReprimands;
